import React from "react";
import "./common/styles/main.scss";
import AuthWrapper from "./app/AuthWrapper";
import { AuthProvider } from "react-oauth2-code-pkce";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import "react-loading-skeleton/dist/skeleton.css";
import { initSentry } from "./common/utils/sentry";
import { buildPortalAuthConfig } from "./common/configs/keycloakAuth";
import { recoverPortalAuthStorage } from "./common/utils/portalWebLogout";

initSentry();
recoverPortalAuthStorage();

const authConfig = buildPortalAuthConfig({
    provider: import.meta.env.VITE_AUTH_PROVIDER,
    authority: import.meta.env.VITE_KEYCLOAK_AUTHORITY,
    keycloakClientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
    authUrl: import.meta.env.VITE_AUTH_URL,
    passportClientId: import.meta.env.VITE_CLIENT_ID,
    portalUrl: import.meta.env.VITE_PORTAL_URL || window.location.origin,
});

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
    <React.StrictMode>
        <AuthProvider authConfig={authConfig}>
            <Provider store={store}>
                <AuthWrapper />
            </Provider>
        </AuthProvider>
    </React.StrictMode>,
);
